// The function reads appDefinitions from the div on the page as well as preinstalled apps
import { __awaiter } from "tslib";
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
import { fetchAppDefinitionsFromAppsService, fetchAppDefinitionsFromPage, fetchPreinstalledApps, } from './api';
import { getSideloadedApps } from './M365AppsLocalSideloadService';
import { m365AppDefinitionsBehaviorSubject } from './state';
export const loadAppDefinitions = (fromPageDiv, appId) => __awaiter(void 0, void 0, void 0, function* () {
    const identityResult = getOfficeIdentity();
    const officeIdentity = identityResult
        ? identityResult
        : yield fetchIdentity();
    let definitionFromAppService = [];
    let definitionFromAppServiceForAppId = [];
    let updatedAppDefinitions = [
        ...m365AppDefinitionsBehaviorSubject.getValue(),
        ...(yield fetchPreinstalledApps()),
        ...getSideloadedApps(officeIdentity.puid || ''),
    ];
    if (appId) {
        // Fetch definitions for the provided appId
        definitionFromAppServiceForAppId =
            yield fetchAppDefinitionsFromAppsService(appId);
        updatedAppDefinitions = [
            ...updatedAppDefinitions,
            ...definitionFromAppServiceForAppId,
        ];
    }
    else {
        // Fetch general definitions when appId is not provided
        definitionFromAppService = fromPageDiv
            ? yield fetchAppDefinitionsFromPage()
            : yield fetchAppDefinitionsFromAppsService();
        updatedAppDefinitions = [
            ...updatedAppDefinitions,
            ...definitionFromAppService,
        ];
    }
    // Don't update already loaded app definitions with empty AppService response
    const shouldNotUpdate = m365AppDefinitionsBehaviorSubject.getValue().length > 0 &&
        definitionFromAppService.length === 0 &&
        definitionFromAppServiceForAppId.length === 0;
    !shouldNotUpdate &&
        m365AppDefinitionsBehaviorSubject.next(updatedAppDefinitions);
});
export const reloadAppDefinitions = () => __awaiter(void 0, void 0, void 0, function* () { return yield loadAppDefinitions(false); });
export const loadAppDefinitionWithAppId = (appId) => __awaiter(void 0, void 0, void 0, function* () { return yield loadAppDefinitions(false, appId); });
//# sourceMappingURL=loadAppDefinitions.js.map